module.exports = __webpack_public_path__ + "static/media/22-en.bd3539f2.svg";